export function shouldSpawnToday(task, today = new Date()) {
  const repeat = typeof task.repeat === "string" ? { type: task.repeat } : task.repeat;
  const fallbackRepeatType = task?.repeatType;
  if ((!repeat || !repeat.type) && task.frequency === "repeat" && !fallbackRepeatType) return true;
  const repeatType = repeat?.type || fallbackRepeatType;
  if (!repeatType) return false;

  const day = today.getDay(); // 0–6
  const todayStr = new Date(today.getTime() - today.getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 10);
  const exceptions = Array.isArray(repeat?.exceptions) ? repeat.exceptions : [];
  if (exceptions.includes(todayStr)) return false;
  const repeatDays = Array.isArray(repeat?.days) ? repeat.days : Array.isArray(task?.customDays) ? task.customDays : [];
  const repeatDay = typeof repeat?.day === "number" ? repeat.day : task?.repeatDay;
  const repeatDate = typeof repeat?.date === "number" ? repeat.date : task?.repeatDate;

  switch (repeatType) {
    case "daily":
      return true;
    case "weekdays": 
      return day >= 1 && day <= 5;
    case "weekends":
      return day === 0 || day === 6;
    case "custom":
      return Array.isArray(repeatDays) && repeatDays.includes(day);
    case "weekly":
      return typeof repeatDay === "number" && day === repeatDay;
    case "monthly":
      return typeof repeatDate === "number" && today.getDate() === repeatDate;
    default:
      return false;
  }
}
